import { createSlider, getObserver, layoutRecalcManager, layoutPhaseMeasure, layoutPhaseApply } from '@theme/theme-global';

if (!customElements.get('product-videos')) {
  class ProductVideos extends HTMLDivElement {
    constructor() {
      super();
      this.sliderInstance = null;
      this._observer = null;
      this._lastWidth = null;
      this.recalculateLayout = this.recalculateLayout.bind(this);
    }

    connectedCallback() {
      if (!this.sliderInstance) {
        this.init();
      }
    }

    disconnectedCallback() {
      layoutRecalcManager.unregister(this.recalculateLayout);
      if (this._observer) {
        this._observer.unobserve(this);
        this._observer = null;
      }
      if (this.sliderInstance && !this.sliderInstance.destroyed) {
        this.sliderInstance.destroy(true, true);
      }
      this.sliderInstance = null;
    }

    init() {
      if (!this.dataset.params) return;

      const initSlider = () => {
        if (this.sliderInstance || this._sliderInitializing) return;
        this._sliderInitializing = true;

        createSlider(this, JSON.parse(this.dataset.params))
          .then((instance) => {
            this.sliderInstance = instance;
            this._lastWidth = window.innerWidth;
            layoutRecalcManager.register(this.recalculateLayout, { root: this });
          })
          .finally(() => {
            this._sliderInitializing = false;
          });
      };

      if ('IntersectionObserver' in window) {
        this._observer = getObserver({ rootMargin: '300px 0px', threshold: 0 }, true, false);
        this._observer.observe(this, initSlider);
      } else {
        initSlider();
      }
    }

    recalculateLayout(phase) {
      if (layoutPhaseMeasure(phase)) {
        this._pendingWidth = window.innerWidth;
      }

      if (layoutPhaseApply(phase)) {
        const width = this._pendingWidth ?? window.innerWidth;
        if (width === this._lastWidth) return;
        this._lastWidth = width;

        if (this.sliderInstance && !this.sliderInstance.destroyed) {
          this.sliderInstance.update();
        }
      }
    }
  }

  customElements.define('product-videos', ProductVideos, { extends: 'div' });
}
